import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-aide',
  templateUrl: './aide.component.html',
  styleUrls: ['./aide.component.css'],
})
export class AideComponent {
  supportEmail = environment.supportEmail;
  supportPhone = environment.supportPhone;
  supportWhatsapp = environment.supportWhatsapp;

  /** Message pré-rempli à l'ouverture de WhatsApp */
  private readonly whatsappMessage = "Bonjour TiPay, j'ai besoin d'aide.";

  /** wa.me attend le numéro au format international, chiffres uniquement (sans +, espaces ni tirets) */
  get whatsappLink(): string {
    const number = (this.supportWhatsapp || '').replace(/\D/g, '');
    return `https://wa.me/${number}?text=${encodeURIComponent(this.whatsappMessage)}`;
  }

  get phoneLink(): string {
    return `tel:${(this.supportPhone || '').replace(/\s+/g, '')}`;
  }

  get emailLink(): string {
    return `mailto:${this.supportEmail}?subject=${encodeURIComponent('Demande d’assistance TiPay')}`;
  }

  /** +221778848201 -> +221 77 884 82 01 */
  formatPhone(value: string): string {
    const digits = (value || '').replace(/\D/g, '');
    const m = digits.match(/^221(\d{2})(\d{3})(\d{2})(\d{2})$/);
    return m ? `+221 ${m[1]} ${m[2]} ${m[3]} ${m[4]}` : value;
  }
}